import useRequest from '@/websdk/utils/request';
export default (function () {
  const { isRequestSuccessed, exec } = useRequest({
    url: `/api/maintain/group/detail`,
    name: 'MAINTAIN_GROUP_DETAIL_POST',
    method: 'POST',
  });
  return [isRequestSuccessed, exec];
});
